globalThis.__REHAJE_LOGGEDS__ ??= []
const globalLoggeds = globalThis.__REHAJE_LOGGEDS__

function createLogOnce(type: 'error' | 'log' | 'warn') {
  return function logOnce(msg: string, ...args: any[]) {
    const key = `${type}:${msg}`
    if (globalLoggeds.includes(key)) return
    globalLoggeds.push(key)
    globalThis.console[type](msg, ...args)
  }
}

export const logErrorOnce = createLogOnce('error')
export const logWarnOnce = createLogOnce('warn')
export const logLogOnce = createLogOnce('log')
